angular.module('rjmNg.api').factory('Figures', [
  "$cacheFactory"
  "phpServiceUrl"
  "$http"
  "$q"
  "app"
  "modelFactory"
  "serviceUrl"
  ($cacheFactory, phpServiceUrl, $http, $q, app, modelFactory, serviceUrl) ->
    options =
      cacheOptions:
        deleteOnExpire: 'passive'
        maxAge: (60*60*1000) # one hour

    servUrl = serviceUrl("/clients/#{app.getClientId()}/figures")
    Figures = modelFactory(phpServiceUrl("/client/#{app.getClientId()}/figure"), options)

    class FigureClass extends Figures
      @getRequestOptions: (getData, getQuery) ->
        return requestOptions =
          params:
            data: getData and not app.hasFeatureFlag('RJQL_SERVICE_CLIENT')
            query: getQuery

      # These are identical to the model
      # and serve as an example as to how
      # to extend methods/perform preprocessing
      # on figures before they're saved.
      @save: (model, httpOptions={}) ->
        $cacheFactory.get(servUrl)?.removeAll()
        super model, httpOptions

      @create: (model, httpOptions={}) ->
        $cacheFactory.get(servUrl)?.removeAll()
        super model, httpOptions

      # We want to ensure that when we're @get-ting a figure
      # model from cache, the httpOptions being requested
      # match the cached httpOptions.
      _lastGetHttpOptions = []

      @get: (modelId, forceGet, httpOptions) ->
        httpOptionsDontMatch = not forceGet and
          not angular.equals(httpOptions, _lastGetHttpOptions[+modelId])

        if httpOptionsDontMatch then forceGet = true

        if forceGet then _lastGetHttpOptions[+modelId] = httpOptions

        super modelId, forceGet, httpOptions

      @getAllFigures: (forceGet = false) ->
        deferred = $q.defer()
        $http(
          withCredentials: true
          headers:
            Accept: 'application/json'
            'Content-Type': 'application/json'
          method: 'GET'
          url: servUrl
          cache: $cacheFactory.get(servUrl) || $cacheFactory(servUrl)
        ).then (successResponse) ->
          deferred.resolve(successResponse.data)
        , (errorResponse) ->
          deferred.reject(errorResponse)

        return deferred.promise

      @getByDashboardId: (dashboardId) ->
        deferred = $q.defer()
        $http
          withCredentials: true
          headers:
            Accept: 'application/json'
            'Content-Type': 'application/json'
          method: 'GET'
          url: serviceUrl("/dashboards/#{dashboardId}/figures")
        .then ({data}) ->
          xformedData = data.map (f) ->
            id: f.id
            clientId: f.client_id
            name: f.name
            presentation: f.presentation
            description: f.description
            rjqlId: f.rjql_id
            userId: f.user_id
            reportQueryType: f.query_type
            presentationVersion: f.presentation_version
            presentationType: {id: f.type}
            state: {id: f.state}
          deferred.resolve xformedData
        .catch (error) ->
          deferred.reject error

        deferred.promise

      # get debug information for the figure
      @debug: (modelId, httpOptions={}) =>
        deferred = $q.defer()
        httpObject = angular.extend {}, @httpConfig, httpOptions,
          method: 'GET'
          url: @url+"/#{modelId}/debug"
        $http(httpObject)
        .then (successResponse) ->
          deferred.resolve successResponse.data
        , (errorResponse) ->
          deferred.reject errorResponse.data

        return deferred.promise

      @dependents: (modelId) ->
        deferred = $q.defer()
        $http(
          method: 'GET',
          url: @url+"/#{modelId}/dependents"
        ).then (successResponse) ->
          deferred.resolve(successResponse.data)
        , (errorResponse) ->
          deferred.reject(errorResponse)

        return deferred.promise

      @delete: (modelId) ->
        deferred = $q.defer()
        $http(
          method: 'DELETE',
          url: @url+"/#{modelId}"
        ).then (successResponse) ->
        # Continue to delete chartCache until we are sure it is unsed anywhere else
          $cacheFactory.get('chartCache')?.removeAll()
          $cacheFactory.get(servUrl)?.removeAll()
          $cacheFactory.get('EmailSummary.getAll')?.removeAll()
          $cacheFactory.get('EmailSummary.get')?.removeAll()
          deferred.resolve(successResponse.data)
        , (errorResponse) ->
          deferred.reject(errorResponse)

        return deferred.promise

      $save: (httpOptions={}) =>
        super httpOptions

    return FigureClass
  ]
)
